module.exports = __webpack_public_path__ + "media/images/alumni/Untitled-5-74d5fbda9874e8ce51e00667317aaa32.png";